import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import FormSectionHeading from 'components/atoms/form/FormSectionHeading';
import { HelpIcon } from 'components/atoms/HelpIcon';

const helpText = <Popover id="channel-visibility" placement="right" title="What does Channel Visibility mean?">
   Channel Visibility settings determine what channels will be visible in the dashboard's sidebar navigation.
</Popover>;

const ChannelVisbilitySubHeading = props => (
    <FormSectionHeading marginTop={props.marginTop} marginBottomModifier={props.marginBottomModifier} >
        Channel Visibility
        <OverlayTrigger trigger="click" placement="right" overlay={helpText}>
            <HelpIcon />
        </OverlayTrigger>
    </FormSectionHeading>
);


export default ChannelVisbilitySubHeading;



// WEBPACK FOOTER //
// ./src/components/molecules/ChannelVisibilitySubHeading.js